import { useSound } from './useSound.hook';

/**
 * A hook for playing win sound effects
 * @param options Optional configuration options for the sound
 * @returns An object with functions to control the win sound
 */
export const useWinSound = (options?: {
  volume?: number;
  interrupt?: boolean;
  playbackRate?: number;
}) => {
  return useSound('win', {
    volume: options?.volume ?? 0.25, // Higher volume for celebratory win sounds
    interrupt: options?.interrupt ?? true, // Allow interrupting previous win sounds
    playbackRate: options?.playbackRate ?? 1,
  });
};
